/* Schließplanrechner MVP v2 — Kersten Sicherheitstechnik
 * Graefe-Layout: EINE Kreuztabelle (Zeilen = Zylinder/Türen, Spalten = Schlüssel,
 * Schnittpunkte = Berechtigungs-Checkboxen). Inline-Editoren in der Tabelle.
 * Produktdaten live via /products/<handle>.js, Warenkorb via Cart API.
 * Stand: 2026-10-05 — GA4-Events (Präfix rechner_) über window.gtag des Google-&-YouTube-App-Pixels;
 *   gtag existiert nur nach Cookie-Einwilligung → ohne Einwilligung wird nichts gesendet. Keine Namen/Formularinhalte.
 * Stand: 2026-10-02 — Vorlage „Einfamilienhaus" = kleine Schließanlage (Gärtner nur Garage + Gartentor);
 *   Vorlagen-Türen mit Bauform + Länge; Serienwechsel behält Bauform + Länge.
 * Stand: 2026-09-30 — Schlüsselprodukt je Serie (Block „schluessel“), Serie bleibt bei Vorlagenwechsel;
 *   je Zylinder sind KEYS_PER_CYL Schlüssel inklusive (Bene: ABUS Pfaffenhain liefert 3 je Zylinder),
 *   berechnet werden nur Schlüssel darüber hinaus. */
(function () {
  'use strict';

  var root = document.getElementById('spr-app');
  if (!root) return;
  var CFG = JSON.parse(root.getAttribute('data-spr-config') || '{}');
  var KEYS_PER_CYL = (typeof CFG.keysPerCylinder === 'number' && CFG.keysPerCylinder >= 0) ? CFG.keysPerCylinder : 3;

  var products = []; // { handle, label, data }
  var keyProduct = null;          // Schlüsselprodukt der aktiven Serie
  var keyProductsBySerie = {};     // Serie -> Schlüsselprodukt (Block „Schlüssel-Produkt je Serie“)
  var keyProductDefault = null;    // Fallback: Section-Einstellung key_product_handle
  var state = { doors: [], keys: [], matrix: {}, serie: null }; // matrix["doorId:keyId"] = true
  var editingDoorId = null, editingKeyId = null;   // nicht persistiert
  var uid = 0;
  function nextId(p) { uid += 1; return p + uid; }

  // Duplizieren (Bene 13.10.): Kopie übernimmt alles, Name zählt hoch („Wohnung 1" → „Wohnung 2", sonst „Name 2"), frei = noch nicht vergeben.
  function naechsterName(name, vergeben) {
    var m = /^(.*?)(\d+)\s*$/.exec(name || '');
    var basis = m ? m[1] : (name ? name + ' ' : ''), n = m ? parseInt(m[2], 10) + 1 : 2;
    if (!name) return '';
    while (vergeben.indexOf(basis + n) !== -1) n++;
    return basis + n;
  }
  // Reihenfolge ändern (Bene 13.10.): Pfeilknöpfe im Editor (überall) + Drag & Drop an den Köpfen (Desktop).
  function move(list, item, delta) {
    var i = list.indexOf(item), j = i + delta;
    if (i < 0 || j < 0 || j >= list.length) return;
    list.splice(i, 1); list.splice(j, 0, item); render(); save();
  }
  function moveTo(list, item, zielIndex) {
    var i = list.indexOf(item); if (i < 0) return;
    list.splice(i, 1); list.splice(Math.max(0, Math.min(zielIndex, list.length)), 0, item); render(); save();
  }
  var drag = null;   // { art: 'key'|'door', id }
  function dndAttrs(art, obj, list) {
    return {
      draggable: 'true',
      ondragstart: function (ev) { drag = { art: art, id: obj.id }; ev.dataTransfer.effectAllowed = 'move'; try { ev.dataTransfer.setData('text/plain', obj.id); } catch (e) {} ev.currentTarget.classList.add('spr-dragging'); },
      ondragend: function (ev) { drag = null; ev.currentTarget.classList.remove('spr-dragging'); root.querySelectorAll('.spr-drop').forEach(function (x) { x.classList.remove('spr-drop'); }); },
      ondragover: function (ev) { if (drag && drag.art === art && drag.id !== obj.id) { ev.preventDefault(); ev.dataTransfer.dropEffect = 'move'; ev.currentTarget.classList.add('spr-drop'); } },
      ondragleave: function (ev) { ev.currentTarget.classList.remove('spr-drop'); },
      ondrop: function (ev) {
        ev.preventDefault();
        if (!drag || drag.art !== art || drag.id === obj.id) return;
        var von = list.filter(function (x) { return x.id === drag.id; })[0]; if (!von) return;
        moveTo(list, von, list.indexOf(obj)); drag = null;
      }
    };
  }
  function duplicateDoor(door) {
    var idx = state.doors.indexOf(door);
    var kopie = { id: nextId('d'), name: naechsterName(door.name, state.doors.map(function (d) { return d.name; })), qty: door.qty, productIdx: door.productIdx, variantId: door.variantId };
    state.doors.splice(idx + 1, 0, kopie);
    state.keys.forEach(function (k) { if (state.matrix[door.id + ':' + k.id]) state.matrix[kopie.id + ':' + k.id] = true; });
    editingDoorId = kopie.id; editingKeyId = null; render(); save();
    var inp = root.querySelector('.spr-editor-row input[type=text]'); if (inp) { inp.focus(); inp.select(); }
  }
  function duplicateKey(key) {
    var idx = state.keys.indexOf(key);
    var kopie = { id: nextId('k'), name: naechsterName(key.name, state.keys.map(function (k) { return k.name; })), qty: key.qty, variantId: key.variantId };
    state.keys.splice(idx + 1, 0, kopie);
    state.doors.forEach(function (d) { if (state.matrix[d.id + ':' + key.id]) state.matrix[d.id + ':' + kopie.id] = true; });
    editingKeyId = kopie.id; editingDoorId = null; render(); save();
    var inp = root.querySelector('.spr-key-editor-panel input[type=text]'); if (inp) { inp.focus(); inp.select(); }
  }

  function money(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  /* ---------- Messung (GA4) ----------
   * window.gtag legt das Google-&-YouTube-App-Pixel erst nach Cookie-Einwilligung an (geprüft 05.10.2026:
   * „Ablehnen" → kein gtag, keine Requests). Bis gtag da ist (Ladezeit oder spätere Einwilligung auf derselben
   * Seite), warten Events in einer kleinen Schlange; ohne Einwilligung wird nichts gesendet.
   * Parameter nur anonym: Serie, Vorlage, Anzahlen, Wert — keine Tür-/Schlüsselnamen, keine Formularinhalte.
   * Fehler in der Messung dürfen den Rechner nie stören (alles in try/catch). */
  var GA_ID = 'G-PWK3BZKWWH';
  var gaQueue = [], gaTimer = null, gaBis = Date.now() + 10 * 60 * 1000;
  function gaFlush() {
    try {
      if (typeof window.gtag === 'function') {
        var q = gaQueue; gaQueue = [];
        clearInterval(gaTimer); gaTimer = null;
        q.forEach(function (e) { window.gtag('event', e[0], e[1]); });
      } else if (Date.now() > gaBis) { clearInterval(gaTimer); gaTimer = null; gaQueue = []; }
    } catch (e) { /* Messung optional */ }
  }
  // Achtung: gtag bündelt Events ~5 s und verwirft das Bündel bei Seitenwechsel im selben Tab (geprüft 05.10.2026,
  // auch event_callback/transport_type 'beacon' helfen nicht). Events direkt vor einer Navigation deshalb an die
  // Folgeseite übergeben (Warenkorb: sessionStorage → Section schliessplan-cart sendet auf /cart).
  function gaParams(params) {
    var p = { send_to: GA_ID };
    Object.keys(params || {}).forEach(function (k) { if (params[k] !== undefined && params[k] !== null) p[k] = params[k]; });
    return p;
  }
  function track(name, params) {
    try {
      var p = gaParams(params);
      if (typeof window.gtag === 'function' && !gaQueue.length) { window.gtag('event', name, p); return; }
      if (gaQueue.length < 50) gaQueue.push([name, p]);
      if (!gaTimer) gaTimer = setInterval(gaFlush, 1000);
    } catch (e) { /* Messung optional */ }
  }
  // Gemeinsame Parameter: Serie, Vorlage, Anzahl Zylinder/Schlüssel (Stückzahlen), Wert in EUR (inkl. MwSt.)
  function gaBasis() {
    var p = { serie: state.serie || '(keine)', vorlage: state.vorlage || '(keine)' };
    try { var t = totals(); p.anzahl_zylinder = t.nDoors; p.anzahl_schluessel = t.nKeys; p.wert = Math.round(t.total) / 100; } catch (e) { /* egal */ }
    return p;
  }
  function gaMitWert(p) { p.value = p.wert; p.currency = 'EUR'; return p; }
  // „Einmal je Sitzung" (Browser-Tab) — z. B. Berechtigung geändert, sonst Event-Flut
  function einmalJeSitzung(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1'); return true;
    } catch (e) {
      if (einmalJeSitzung.mem[key]) return false;
      einmalJeSitzung.mem[key] = true; return true;
    }
  }
  einmalJeSitzung.mem = {};
  var GA_ANFRAGE_KEY = 'kst-spr-ga-anfrage';

  /* ---------- Vorlagen ---------- */
  var TEMPLATES = {
    leer: {
      doors: [['Tür 1', 1]], keys: [['Schlüssel 1', 1]],
      grant: function () { return true; }
    },
    // Tür: [Name, Anzahl, Bauform (dz|hz|knz, optional), Länge wie im Dropdown (optional)]
    efh: {
      doors: [['Haustür', 1, 'dz', '30 / 35 mm'], ['Kellertür', 1, 'dz', '30 / 30 mm'],
              ['Garage', 1, 'hz', '10 / 30 mm'], ['Gartentor', 1, 'hz', '10 / 30 mm']],
      keys: [['Hausschlüssel', 4], ['Gärtner', 1]],
      grant: function (d, k) {
        if (k === 0) return true;                 // Hausschlüssel: alles
        return d === 2 || d === 3;                // Gärtner: nur Garage + Gartentor
      }
    },
    mfh: {
      doors: [['Haustür', 1], ['Wohnung 1', 1], ['Wohnung 2', 1], ['Wohnung 3', 1], ['Kellertür', 1]],
      keys: [['Mieter Wo. 1', 2], ['Mieter Wo. 2', 2], ['Mieter Wo. 3', 2], ['Hausmeister', 1]],
      grant: function (d, k) {
        if (k === 3) return true;                 // Hausmeister: alles
        if (d === 0 || d === 4) return true;      // Haustür + Keller: alle Mieter
        return d === k + 1;                       // eigene Wohnung
      }
    },
    komplex: {
      doors: [['Haupteingang', 1], ['Büro 1', 1], ['Büro 2', 1], ['Besprechung', 1], ['Lager', 1], ['Technikraum', 1]],
      keys: [['General', 2], ['Büro 1', 3], ['Büro 2', 3], ['Lager', 2], ['Technik', 1]],
      grant: function (d, k) {
        if (k === 0) return true;                 // Generalschlüssel: alles
        if (d === 0) return true;                 // Haupteingang: alle
        var map = { 1: [1, 3], 2: [2, 3], 3: [4], 4: [5] }; // key -> doors
        return (map[k] || []).indexOf(d) !== -1;
      }
    }
  };

  function applyTemplate(name) {
    var t = TEMPLATES[name];
    if (!t) return;
    state = { doors: [], keys: [], matrix: {}, serie: state.serie, vorlage: name };   // Serie beibehalten, Vorlage merken (grün markiert)
    editingDoorId = editingKeyId = null;
    t.doors.forEach(function (d) {
      var pIdx = d[2] ? bauformProductIdx(d[2]) : defaultProductIdx();
      var vid = (d[3] && variantIdByLabel(pIdx, d[3])) || defaultVariantId(pIdx);
      state.doors.push({ id: nextId('d'), name: d[0], qty: d[1], productIdx: pIdx, variantId: vid });
    });
    t.keys.forEach(function (k) {
      state.keys.push({ id: nextId('k'), name: k[0], qty: k[1], variantId: defaultKeyVariantId() });
    });
    state.doors.forEach(function (d, di) {
      state.keys.forEach(function (k, ki) {
        if (t.grant(di, ki)) state.matrix[d.id + ':' + k.id] = true;
      });
    });
    render(); save();
  }

  function defaultVariantId(pIdx) {
    var p = products[pIdx] && products[pIdx].data;
    if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i].id;
    return p.variants.length ? p.variants[0].id : null;
  }
  function defaultKeyVariantId() {
    if (!keyProduct) return null;
    for (var i = 0; i < keyProduct.variants.length; i++) if (keyProduct.variants[i].available) return keyProduct.variants[i].id;
    return keyProduct.variants.length ? keyProduct.variants[0].id : null;
  }
  // Bauform aus dem Produkt-Handle (gleich aufgebaut in allen Serien)
  function bauformOf(pIdx) {
    var h = (products[pIdx] && products[pIdx].handle) || '';
    return /halbzylinder/.test(h) ? 'hz' : /knaufzylinder/.test(h) ? 'knz' : /doppelzylinder/.test(h) ? 'dz' : '';
  }
  // Produkt der aktiven Serie mit dieser Bauform, sonst erstes Produkt der Serie
  function bauformProductIdx(bf) {
    for (var i = 0; i < products.length; i++) if (produktPasst(i) && bauformOf(i) === bf) return i;
    return defaultProductIdx();
  }
  // Verfügbare Variante mit derselben Längenbezeichnung („30 / 35 mm", „10 / 30 mm", „30 Knauf / 35")
  function variantIdByLabel(pIdx, label) {
    var p = products[pIdx] && products[pIdx].data;
    if (!p || !label) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available && variantLabel(p, p.variants[i]) === label) return p.variants[i].id;
    }
    return null;
  }
  function findVariant(pData, vid) {
    if (!pData) return null;
    for (var i = 0; i < pData.variants.length; i++) if (pData.variants[i].id === vid) return pData.variants[i];
    return null;
  }

  /* ---------- Persistenz (localStorage) ---------- */
  var LS_KEY = 'kst-schliessplan-v1';
  function save() {
    try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) { /* egal */ }
    try { var _sp = root.querySelector('#spr-share-panel'); if (_sp && !_sp.hidden) shareRefresh(); } catch (e) { /* egal */ }
  }
  function restore() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return false;
      var s = JSON.parse(raw);
      if (!s || !s.doors || !s.doors.length) return false;
      // Migration v1 → v2: qty ergänzen
      s.doors.forEach(function (d) { if (!d.qty) d.qty = 1; });
      (s.keys || []).forEach(function (k) { if (!k.qty) k.qty = 1; });
      state = s;
      [].concat(s.doors, s.keys || []).forEach(function (x) {
        var n = parseInt(String(x.id).replace(/^[dk]/, ''), 10);
        if (n > uid) uid = n;
      });
      return true;
    } catch (e) { return false; }
  }
  function clearConfig() {
    if (!window.confirm('Konfiguration wirklich leeren?')) return;
    try { localStorage.removeItem(LS_KEY); } catch (e) { /* egal */ }
    applyTemplate('leer');
    track('rechner_konfiguration_geleert', gaBasis());
  }

  /* ---------- Serien ---------- */
  function serienListe() {
    // Eindeutige Serien in Blockreihenfolge; Produkte ohne Serie zählen als eine namenlose Gruppe.
    var out = [], seen = {};
    products.forEach(function (p) {
      var s = p.serie || '';
      if (!seen[s]) { seen[s] = true; out.push(s); }
    });
    return out.filter(function (s) { return s !== ''; });
  }
  function produktPasst(idx) {
    var p = products[idx];
    if (!p) return false;
    if (!state.serie) return true;
    return (p.serie || '') === state.serie;
  }
  function defaultProductIdx() {
    for (var i = 0; i < products.length; i++) if (produktPasst(i)) return i;
    return 0;
  }
  // Schlüsselprodukt passend zur aktiven Serie setzen; Schlüssel-Varianten ggf. umhängen.
  function syncKeyProduct() {
    keyProduct = (state.serie && keyProductsBySerie[state.serie]) || keyProductDefault;
    state.keys.forEach(function (k) {
      if (!findVariant(keyProduct, k.variantId)) k.variantId = defaultKeyVariantId();
    });
  }
  function setSerie(s) {
    if (s === state.serie) return;
    state.serie = s;
    syncKeyProduct();
    state.doors.forEach(function (d) {
      if (!produktPasst(d.productIdx)) {
        // gleiche Bauform + Länge in der neuen Serie, sonst Standard der Serie
        var alt = products[d.productIdx], altV = findVariant(alt && alt.data, d.variantId);
        var label = altV ? variantLabel(alt.data, altV) : '';
        var bf = bauformOf(d.productIdx);
        var idx = bf ? bauformProductIdx(bf) : defaultProductIdx();
        d.productIdx = idx;
        d.variantId = variantIdByLabel(idx, label) || defaultVariantId(idx);
      }
    });
    renderSerien(); render(); save();
  }
  // Serienkarten: Name, wofür steht die Serie (Kurz + Punkte aus Block „Serien-Info“), Einstiegspreis automatisch.
  function serienInfo(s) {
    var list = CFG.serienInfo || [];
    for (var i = 0; i < list.length; i++) if (list[i].serie === s) return list[i];
    return null;
  }
  function einstiegspreis(s) {
    for (var i = 0; i < products.length; i++) {
      if ((products[i].serie || '') !== s || !products[i].data) continue;
      var min = null;
      products[i].data.variants.forEach(function (v) { if (v.available && (min === null || v.price < min)) min = v.price; });
      if (min === null) return '';
      return (products[i].label || '').replace(/\s*\(.*\)\s*$/, '') + ' ab ' + money(min);
    }
    return '';
  }
  function renderSerien() {
    var wrap = root.querySelector('#spr-serien');
    if (!wrap) return;
    wrap.textContent = '';
    var liste = serienListe();
    liste.forEach(function (s) {
      var aktiv = s === state.serie;
      var info = serienInfo(s) || {};
      var teile = [el('span', { class: 'spr-serie-name', text: s })];
      if (info.kurz) teile.push(el('span', { class: 'spr-serie-kurz', text: info.kurz }));
      (info.punkte || []).forEach(function (p) { if (p) teile.push(el('span', { class: 'spr-serie-punkt', text: p })); });
      var preis = einstiegspreis(s);
      if (preis) teile.push(el('span', { class: 'spr-serie-preis', text: preis }));
      if (aktiv) teile.push(el('span', { class: 'spr-serie-marke', text: '✓ Ausgewählt' }));
      wrap.appendChild(el('button', {
        type: 'button',
        class: 'spr-serie-btn' + (aktiv ? ' spr-serie-aktiv' : ''),
        'aria-pressed': aktiv ? 'true' : 'false',
        'aria-label': s + (info.kurz ? ' — ' + info.kurz : ''),
        onclick: function () {
          var neu = s !== state.serie;
          setSerie(s);
          if (neu) track('rechner_serie_gewaehlt', gaBasis());
        }
      }, teile));
    });
    (CFG.platzhalter || []).forEach(function (name) {
      var b = el('button', {
        type: 'button', class: 'spr-serie-btn spr-serie-bald',
        title: 'Diese Serie nehmen wir später auf'
      }, [el('span', { class: 'spr-serie-name', text: name }), el('span', { class: 'spr-serie-kurz', text: 'Folgt in Kürze' })]);
      b.disabled = true;
      wrap.appendChild(b);
    });
  }

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') e.textContent = attrs[k];
      else if (k.indexOf('on') === 0) e.addEventListener(k.slice(2), attrs[k]);
      else e.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { e.appendChild(c); });
    return e;
  }

  /* ---------- Editoren ---------- */
  function variantAxes(pData) {
    // Nur Optionen mit mehr als einem Wert sind echte Auswahl-Achsen.
    // Einwert-Optionen (z. B. „Schließung: in Schließanlage") werden nicht als Gruppe/Label angezeigt.
    var axes = [];
    for (var i = 1; i <= 3; i++) {
      var seen = {}, n = 0;
      pData.variants.forEach(function (v) { var val = v['option' + i]; if (val && !seen[val]) { seen[val] = true; n++; } });
      if (n > 1) axes.push(i);
    }
    return axes;
  }
  function variantLabel(pData, v) {
    // Vollständige Bezeichnung aus allen echten Auswahl-Achsen; Einwert-Optionen
    // („Schließung: in Schließanlage") bleiben weg. Zwei Längen -> „30 / 40 mm".
    if (!pData || !v) return '';
    var axes = variantAxes(pData);
    if (!axes.length) return v.title;
    var parts = [];
    axes.forEach(function (i) {
      var val = (v['option' + i] || '').trim();
      if (val) parts.push(val);
    });
    if (!parts.length) return v.title;
    // Halbzylinder: ABUS-Schreibweise „10 / 30 mm" (Maß A ist beim Halbzylinder immer 10 mm, vgl. SKU …HZ.10-30)
    if (/halbzylinder/.test(pData.handle || '') && parts.length === 1 && /^\d+\s*mm$/.test(parts[0])) parts[0] = '10 / ' + parts[0];
    var alleMm = parts.every(function (p) { return /\smm$/.test(p); });
    if (parts.length > 1 && alleMm) {
      parts = parts.map(function (p, idx) {
        return idx === parts.length - 1 ? p : p.replace(/\s*mm$/, '');
      });
    }
    return parts.join(' / ');
  }

  function variantSelect(door) {
    var pData = products[door.productIdx] && products[door.productIdx].data;
    var sel = el('select', {
      'aria-label': 'Zylinderlänge',
      onchange: function (ev) { door.variantId = parseInt(ev.target.value, 10); render(); save(); }
    });
    if (!pData) { sel.disabled = true; return sel; }
    var axes = variantAxes(pData), groupOf, labelOf;
    if (axes.length >= 2) {
      groupOf = function (v) { return 'Maß A ' + v['option' + axes[0]]; };
      labelOf = function (v) { return variantLabel(pData, v); };
    } else if (axes.length === 1 && pData.variants.length > 20) {
      // Eine lange Achse (z. B. Knaufzylinder „30 Knauf / 35"): nach führendem Maß gruppieren
      groupOf = function (v) { var m = /^(\d+)/.exec(v['option' + axes[0]] || ''); return m ? 'Maß A ' + m[1] + ' mm' : ''; };
      labelOf = function (v) { return variantLabel(pData, v); };
    } else {
      groupOf = function () { return ''; };
      labelOf = function (v) { return variantLabel(pData, v); };
    }
    var groups = {}, order = [];
    pData.variants.forEach(function (v) {
      var g = groupOf(v) || '';
      if (!groups[g]) { groups[g] = []; order.push(g); }
      groups[g].push(v);
    });
    order.forEach(function (g) {
      var parent = g ? el('optgroup', { label: g }) : sel;
      groups[g].forEach(function (v) {
        var label = labelOf(v) + ' — ' + money(v.price) + (v.available ? '' : ' (nicht verfügbar)');
        var o = el('option', { value: v.id, text: label });
        if (!v.available) o.disabled = true;
        if (v.id === door.variantId) o.selected = true;
        parent.appendChild(o);
      });
      if (g) sel.appendChild(parent);
    });
    return sel;
  }

  // Eingabefelder im Editor: Wert beim Tippen übernehmen, OHNE den Editor neu aufzubauen (sonst tauscht der Neuaufbau
  // beim Verlassen des Feldes den „Fertig"-Knopf aus und der erste Klick geht ins Leere). Enter = Fertig.
  function liveUpdate(ev, preisText) {
    renderSummary();
    var pv = root.querySelector('#spr-plan-preview'); if (pv) pv.textContent = planText();
    var ed = ev.target.closest('.spr-editor'), sp = ed && ed.querySelector('.spr-editor-price');
    if (sp) sp.textContent = preisText();
    save();
  }
  function feldHandler(obj, feld, istZahl, preisText, schliessen) {
    return {
      oninput: function (ev) {
        if (istZahl) { var n = parseInt(ev.target.value, 10); if (!(n >= 1)) return; obj[feld] = Math.min(99, n); }
        else obj[feld] = ev.target.value;
        liveUpdate(ev, preisText);
      },
      onblur: function (ev) { if (istZahl && String(obj[feld]) !== ev.target.value) ev.target.value = obj[feld]; },
      onkeydown: function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); schliessen(); } }
    };
  }
  function mit(attrs, extra) { Object.keys(extra).forEach(function (k) { attrs[k] = extra[k]; }); return attrs; }

  function doorEditor(door) {
    var prodSel = el('select', {
      'aria-label': 'Zylindertyp',
      onchange: function (ev) {
        door.productIdx = parseInt(ev.target.value, 10);
        door.variantId = defaultVariantId(door.productIdx);
        render(); save();
      }
    });
    products.forEach(function (p, pi) {
      if (!produktPasst(pi) && pi !== door.productIdx) return;
      // Fremde Serie (sollte nicht vorkommen) sichtbar kennzeichnen statt doppelten Namen zu zeigen
      var o = el('option', { value: pi, text: p.label + (produktPasst(pi) ? '' : ' – ' + (p.serie || 'andere Serie')) });
      if (pi === door.productIdx) o.selected = true;
      prodSel.appendChild(o);
    });
    var v = findVariant(products[door.productIdx] && products[door.productIdx].data, door.variantId);
    var dPreis = function () { return v ? (door.qty + ' × ' + money(v.price) + ' = ' + money(v.price * door.qty)) : 'Bitte Variante wählen'; };
    var dZu = function () { editingDoorId = null; render(); };
    return el('div', { class: 'spr-editor' }, [
      el('div', { class: 'spr-editor-grid' }, [
        el('label', { text: 'Bezeichnung' }),
        el('input', mit({ type: 'text', value: door.name, placeholder: 'z. B. Haustür' }, feldHandler(door, 'name', false, dPreis, dZu))),
        el('label', { text: 'Anzahl Zylinder' }),
        el('input', mit({ type: 'number', min: '1', max: '99', value: door.qty }, feldHandler(door, 'qty', true, dPreis, dZu))),
        el('label', { text: 'Zylindertyp' }),
        prodSel,
        el('label', { text: 'Zylinderlänge' }),
        variantSelect(door)
      ]),
      el('div', { class: 'spr-editor-foot' }, [
        el('span', { class: 'spr-editor-price', text: dPreis() }),
        el('button', { class: 'spr-btn-mini spr-btn-move', type: 'button', text: '▲', title: 'Nach oben verschieben', 'aria-label': 'Zylinder nach oben verschieben', onclick: function () { move(state.doors, door, -1); } }),
        el('button', { class: 'spr-btn-mini spr-btn-move', type: 'button', text: '▼', title: 'Nach unten verschieben', 'aria-label': 'Zylinder nach unten verschieben', onclick: function () { move(state.doors, door, 1); } }),
        el('button', {
          class: 'spr-btn-mini', type: 'button', text: 'Duplizieren', title: 'Kopie mit gleicher Länge und gleichen Schlüsseln anlegen',
          onclick: function () { duplicateDoor(door); }
        }),
        el('button', {
          class: 'spr-btn-mini spr-btn-danger', type: 'button', text: 'Zylinder entfernen',
          onclick: function () {
            state.doors = state.doors.filter(function (d) { return d.id !== door.id; });
            editingDoorId = null; cleanMatrix(); render(); save();
          }
        }),
        el('button', {
          class: 'spr-btn-mini', type: 'button', text: 'Fertig',
          onclick: dZu
        })
      ])
    ]);
  }

  function keyPriceText(key, v) {
    var r = keyAllocation().byId[key.id];
    var free = r ? r.free : 0, paid = r ? r.paid : key.qty;
    if (!free) return paid + ' × ' + money(v.price) + ' = ' + money(v.price * paid);
    if (!paid) return key.qty + ' Schlüssel inklusive = ' + money(0);
    return free + ' inklusive + ' + paid + ' × ' + money(v.price) + ' = ' + money(v.price * paid);
  }

  function keyEditor(key) {
    var colorSel = el('select', {
      'aria-label': 'Schlüssel-Ausführung',
      onchange: function (ev) { key.variantId = parseInt(ev.target.value, 10); render(); save(); }
    });
    if (keyProduct) {
      keyProduct.variants.forEach(function (v) {
        var o = el('option', { value: v.id, text: (keyProduct.variants.length === 1 && keyProduct.title ? keyProduct.title : v.title) + ' — ' + money(v.price) });
        if (!v.available) o.disabled = true;
        if (v.id === key.variantId) o.selected = true;
        colorSel.appendChild(o);
      });
    } else { colorSel.disabled = true; }
    var v = keyProduct ? findVariant(keyProduct, key.variantId) : null;
    var kPreis = function () { return v ? keyPriceText(key, v) : '—'; };
    var kZu = function () { editingKeyId = null; render(); };
    return el('div', { class: 'spr-editor' }, [
      el('div', { class: 'spr-editor-grid' }, [
        el('label', { text: 'Bezeichnung' }),
        el('input', mit({ type: 'text', value: key.name, placeholder: 'z. B. Hausmeister' }, feldHandler(key, 'name', false, kPreis, kZu))),
        el('label', { text: 'Anzahl Schlüssel' }),
        el('input', mit({ type: 'number', min: '1', max: '99', value: key.qty }, feldHandler(key, 'qty', true, kPreis, kZu))),
        el('label', { text: 'Ausführung' }),
        colorSel
      ]),
      el('div', { class: 'spr-editor-foot' }, [
        el('span', { class: 'spr-editor-price', text: kPreis() }),
        el('button', { class: 'spr-btn-mini spr-btn-move', type: 'button', text: '◀', title: 'Spalte nach links verschieben', 'aria-label': 'Schlüssel nach links verschieben', onclick: function () { move(state.keys, key, -1); } }),
        el('button', { class: 'spr-btn-mini spr-btn-move', type: 'button', text: '▶', title: 'Spalte nach rechts verschieben', 'aria-label': 'Schlüssel nach rechts verschieben', onclick: function () { move(state.keys, key, 1); } }),
        el('button', {
          class: 'spr-btn-mini', type: 'button', text: 'Duplizieren', title: 'Kopie mit gleichen Berechtigungen anlegen',
          onclick: function () { duplicateKey(key); }
        }),
        el('button', {
          class: 'spr-btn-mini spr-btn-danger', type: 'button', text: 'Schlüssel entfernen',
          onclick: function () {
            state.keys = state.keys.filter(function (k) { return k.id !== key.id; });
            editingKeyId = null; cleanMatrix(); render(); save();
          }
        }),
        el('button', {
          class: 'spr-btn-mini', type: 'button', text: 'Fertig',
          onclick: kZu
        })
      ])
    ]);
  }

  function cleanMatrix() {
    var valid = {};
    state.doors.forEach(function (d) {
      state.keys.forEach(function (k) {
        var mk = d.id + ':' + k.id;
        if (state.matrix[mk]) valid[mk] = true;
      });
    });
    state.matrix = valid;
  }

  /* ---------- Die eine Kreuztabelle (Graefe-Layout) ---------- */
  function renderMatrix() {
    var wrap = root.querySelector('#spr-matrix-wrap');
    wrap.innerHTML = '';
    var cols = state.keys.length + 2; // Zeilenkopf + Keys + Add-Spalte

    // Schlüssel-Editor-Panel (oberhalb der Tabelle, wenn aktiv)
    if (editingKeyId) {
      var ek = state.keys.filter(function (k) { return k.id === editingKeyId; })[0];
      if (ek) {
        var ki = state.keys.indexOf(ek);
        wrap.appendChild(el('div', { class: 'spr-key-editor-panel' }, [
          el('h3', { text: 'Schlüssel S' + (ki + 1) + ' bearbeiten' }),
          keyEditor(ek)
        ]));
      }
    }

    var scroll = el('div', { class: 'spr-matrix-scroll' });
    var table = el('table', { class: 'spr-matrix' });

    // Kopfzeile: Ecke | Schlüsselköpfe (vertikal) | "Schlüssel +"
    var headRow = el('tr', {}, [el('th', { class: 'spr-mx-corner', text: 'Zylinder \\ Schlüssel' })]);
    state.keys.forEach(function (k, ki) {
      var v = keyProduct ? findVariant(keyProduct, k.variantId) : null;
      headRow.appendChild(el('th', mit({ class: 'spr-mx-keyhead' + (editingKeyId === k.id ? ' spr-editing' : ''), title: 'Zum Verschieben ziehen' }, dndAttrs('key', k, state.keys)), [
        el('button', {
          class: 'spr-keyhead-btn', type: 'button',
          title: 'S' + (ki + 1) + (v ? ' · ' + v.title : '') + ' — bearbeiten',
          'aria-label': 'Schlüssel ' + (k.name || ('S' + (ki + 1))) + ' bearbeiten',
          onclick: function () { editingKeyId = (editingKeyId === k.id ? null : k.id); editingDoorId = null; render(); }
        }, [
          el('span', { class: 'spr-vertical', text: k.qty + '× ' + (k.name || 'S' + (ki + 1)) }),
          el('span', { class: 'spr-pencil', text: '✎' })
        ])
      ]));
    });
    headRow.appendChild(el('th', { class: 'spr-mx-add' }, [
      el('button', {
        class: 'spr-add-btn', type: 'button', text: 'Schlüssel +',
        onclick: function () {
          var k = { id: nextId('k'), name: '', qty: 1, variantId: defaultKeyVariantId() };
          state.keys.push(k);
          editingKeyId = k.id; editingDoorId = null;
          render(); save();
          track('rechner_schluessel_hinzugefuegt', gaBasis());
        }
      })
    ]));
    table.appendChild(el('thead', {}, [headRow]));

    // Zeilen: Zylinder/Türen
    var tbody = el('tbody');
    state.doors.forEach(function (d, di) {
      var p = products[d.productIdx];
      var v = findVariant(p && p.data, d.variantId);
      var row = el('tr', {});
      row.appendChild(el('th', mit({ class: 'spr-mx-doorhead' + (editingDoorId === d.id ? ' spr-editing' : ''), title: 'Zum Verschieben ziehen' }, dndAttrs('door', d, state.doors)), [
        el('button', {
          class: 'spr-doorhead-btn', type: 'button',
          'aria-label': 'Tür ' + (d.name || ('Z' + (di + 1))) + ' bearbeiten',
          onclick: function () { editingDoorId = (editingDoorId === d.id ? null : d.id); editingKeyId = null; render(); }
        }, [
          el('span', { class: 'spr-door-z', text: 'Z' + (di + 1) }),
          el('span', { class: 'spr-door-name', text: d.qty + '× ' + (d.name || 'Tür') }),
          el('span', { class: 'spr-pencil', text: '✎' }),
          el('span', { class: 'spr-door-sub' }, [
            el('span', { class: 'spr-door-sub-detail', text: (p ? p.label : '?') + (v ? ' · ' + variantLabel(p && p.data, v) : ' · Variante wählen!') }),
            el('span', { class: 'spr-door-sub-preis', text: v ? money(v.price * d.qty) : '' })
          ])
        ])
      ]));
      state.keys.forEach(function (k) {
        var mk = d.id + ':' + k.id;
        var cb = el('input', {
          type: 'checkbox',
          'aria-label': (k.name || 'Schlüssel') + ' schließt ' + (d.name || 'Tür'),
          onchange: function (ev) {
            if (ev.target.checked) state.matrix[mk] = true; else delete state.matrix[mk];
            render(); save();
            if (einmalJeSitzung('kst-spr-ga-berechtigung')) track('rechner_berechtigung_geaendert', gaBasis());
          }
        });
        if (state.matrix[mk]) cb.checked = true;
        row.appendChild(el('td', { class: state.matrix[mk] ? 'spr-mx-on' : '' }, [cb]));
      });
      row.appendChild(el('td', { class: 'spr-mx-add' }));
      tbody.appendChild(row);

      // Inline-Editor direkt unter der Zeile
      if (editingDoorId === d.id) {
        tbody.appendChild(el('tr', { class: 'spr-editor-row' }, [
          el('td', { colspan: cols }, [doorEditor(d)])
        ]));
      }
    });

    // Fußzeile: "Zylinder +" unten links
    tbody.appendChild(el('tr', {}, [
      el('td', { class: 'spr-mx-foot' }, [
        el('button', {
          class: 'spr-add-btn', type: 'button', text: 'Zylinder +',
          onclick: function () {
            var pIdx = defaultProductIdx();   // Zylinder der GEWÄHLTEN Serie (vorher immer Produkt 0 = Bravus)
            var d = { id: nextId('d'), name: '', qty: 1, productIdx: pIdx, variantId: defaultVariantId(pIdx) };
            state.doors.push(d);
            editingDoorId = d.id; editingKeyId = null;
            render(); save();
            track('rechner_tuer_hinzugefuegt', gaBasis());
          }
        })
      ]),
      el('td', { class: 'spr-mx-foot', colspan: String(cols - 1) })
    ]));

    table.appendChild(tbody);
    scroll.appendChild(table);
    wrap.appendChild(scroll);
  }

  /* ---------- Summen ---------- */
  // Inklusive Schlüssel: KEYS_PER_CYL je Zylinder (Summe aller Zylinder), als Pool über alle Schlüsselzeilen.
  // Verteilung zuerst auf die teuersten Ausführungen, bei Gleichstand in Reihenfolge S1, S2, …
  function keyAllocation() {
    var nDoors = 0;
    state.doors.forEach(function (d) { nDoors += d.qty; });
    var pool = nDoors * KEYS_PER_CYL;
    var rows = state.keys.map(function (k, i) {
      var v = keyProduct ? findVariant(keyProduct, k.variantId) : null;
      return { key: k, idx: i, v: v, price: v ? v.price : 0, free: 0, paid: k.qty };
    });
    rows.slice().sort(function (a, b) { return (b.price - a.price) || (a.idx - b.idx); }).forEach(function (r) {
      var f = Math.min(r.key.qty, pool);
      r.free = f; r.paid = r.key.qty - f; pool -= f;
    });
    var byId = {};
    rows.forEach(function (r) { byId[r.key.id] = r; });
    return { rows: rows, byId: byId, inclusive: nDoors * KEYS_PER_CYL };
  }

  function totals() {
    var sumDoors = 0, sumKeys = 0, nDoors = 0, nKeys = 0, nFree = 0, nPaid = 0, incomplete = false;
    state.doors.forEach(function (d) {
      var v = findVariant(products[d.productIdx] && products[d.productIdx].data, d.variantId);
      if (v) { sumDoors += v.price * d.qty; nDoors += d.qty; } else incomplete = true;
    });
    var alloc = keyAllocation();
    alloc.rows.forEach(function (r) {
      if (r.v) { sumKeys += r.v.price * r.paid; nKeys += r.key.qty; nFree += r.free; nPaid += r.paid; } else incomplete = true;
    });
    return { doors: sumDoors, keys: sumKeys, nDoors: nDoors, nKeys: nKeys, nFree: nFree, nPaid: nPaid,
             inclusive: alloc.inclusive, alloc: alloc, total: sumDoors + sumKeys, incomplete: incomplete };
  }

  function keysNoteText(t) {
    var s = 'Je Zylinder sind ' + KEYS_PER_CYL + ' Schlüssel inklusive — bei ' + t.nDoors + ' Zylinder' + (t.nDoors === 1 ? '' : 'n') +
      ' also ' + t.inclusive + ' Schlüssel ohne Aufpreis.';
    if (t.nPaid > 0) s += ' Berechnet werden nur die ' + t.nPaid + ' zusätzlichen Schlüssel.';
    else if (t.nKeys < t.inclusive) s += ' Sie können noch ' + (t.inclusive - t.nKeys) + ' Schlüssel ohne Aufpreis hinzufügen.';
    return s;
  }

  function renderSummary() {
    var t = totals();
    root.querySelector('#spr-sum-doors').textContent = money(t.doors) + ' (' + t.nDoors + ' Zylinder)';
    root.querySelector('#spr-sum-keys').textContent = money(t.keys) + ' (' + t.nKeys + ' Schlüssel, davon ' + t.nFree + ' inklusive)';
    var note = root.querySelector('#spr-keys-note');
    if (note) note.textContent = keysNoteText(t);
    root.querySelector('#spr-sum-total').textContent = money(t.total);
    root.querySelector('#spr-add-to-cart').disabled = !state.doors.length || t.incomplete;
  }

  // Gewählte Vorlage grün markieren (bleibt auch nach eigenen Änderungen und beim Neuladen stehen)
  function renderVorlagen() {
    root.querySelectorAll('[data-spr-template]').forEach(function (b) {
      var an = b.getAttribute('data-spr-template') === state.vorlage;
      b.classList.toggle('spr-vorlage-aktiv', an);
      b.setAttribute('aria-pressed', an ? 'true' : 'false');
    });
  }
  function render() {
    renderMatrix(); renderSummary(); renderVorlagen();
    root.querySelector('#spr-plan-preview').textContent = planText();
  }

  /* ---------- Schließplan als Text/JSON ---------- */
  function keysForDoor(d) {
    return state.keys.filter(function (k) { return state.matrix[d.id + ':' + k.id]; })
      .map(function (k) { return k.name || 'Schlüssel'; });
  }
  function doorsForKey(k) {
    return state.doors.filter(function (d) { return state.matrix[d.id + ':' + k.id]; })
      .map(function (d) { return d.name || 'Tür'; });
  }
  function planText() {
    var lines = ['SCHLIESSPLAN (' + new Date().toLocaleDateString('de-DE') + ')', ''];
    lines.push('Zylinder / Türen:');
    state.doors.forEach(function (d, i) {
      var p = products[d.productIdx];
      var v = findVariant(p && p.data, d.variantId);
      lines.push('  Z' + (i + 1) + ': ' + d.qty + '× ' + (d.name || 'Tür') + ' — ' + (p ? p.label : '?') + ', ' + (v ? variantLabel(p && p.data, v) + (v.sku ? ' [' + v.sku + ']' : '') : 'keine Variante') + (v ? ' (' + money(v.price) + '/Stk.)' : ''));
      lines.push('       geschlossen von: ' + (keyCodesForDoor(d).join(', ') || 'keinem Schlüssel'));
    });
    lines.push('');
    lines.push('Schlüssel:');
    var t = totals(), alloc = t.alloc;
    state.keys.forEach(function (k, i) {
      var v = keyProduct ? findVariant(keyProduct, k.variantId) : null;
      var r = alloc.byId[k.id];
      var preis = !v ? '' : (r && r.free && !r.paid) ? 'inklusive'
        : (r && r.free) ? r.free + ' inklusive, ' + r.paid + ' × ' + money(v.price)
        : money(v.price) + '/Stk.';
      lines.push('  S' + (i + 1) + ': ' + k.qty + '× ' + (k.name || 'Schlüssel') + (v ? ' — ' + v.title + ' (' + preis + ')' : '') + ' → schließt: ' + (doorsForKey(k).join(', ') || 'keine Tür'));
    });
    lines.push('  Schlüssel gesamt: ' + t.nKeys + ', davon ' + t.nFree + ' inklusive (' + KEYS_PER_CYL + ' je Zylinder), ' + t.nPaid + ' berechnet');
    lines.push('');
    lines.push('Summe Zylinder: ' + money(t.doors) + ' | Summe Schlüssel: ' + money(t.keys) + ' | Gesamt: ' + money(t.total) + ' (inkl. MwSt.)');
    return lines.join('\n');
  }
  function planJson() {
    return JSON.stringify({
      version: 3,
      keysPerCylinder: KEYS_PER_CYL,
      created: new Date().toISOString(),
      doors: state.doors.map(function (d) {
        var p = products[d.productIdx];
        var v = findVariant(p && p.data, d.variantId);
        return { name: d.name, qty: d.qty, product: p ? p.handle : null, variantId: d.variantId, variant: v ? v.title : null, sku: v ? v.sku : null, keys: keysForDoor(d) };
      }),
      keys: state.keys.map(function (k) {
        var v = keyProduct ? findVariant(keyProduct, k.variantId) : null;
        var r = keyAllocation().byId[k.id];
        return { name: k.name, qty: k.qty, inklusive: r ? r.free : 0, berechnet: r ? r.paid : k.qty, variantId: k.variantId, variant: v ? v.title : null, doors: doorsForKey(k) };
      })
    });
  }

  function keyCodesForDoor(d) {
    var out = [];
    state.keys.forEach(function (k, ki) { if (state.matrix[d.id + ':' + k.id]) out.push('S' + (ki + 1) + ' ' + (k.name || 'Schlüssel')); });
    return out;
  }

  /* ---------- Schließplan als Link (#plan=…) ---------- */
  // Kompaktes JSON, base64url: Serie, Türen [Name, Anzahl, Produkt-Handle, Varianten-ID], Schlüssel [Name, Anzahl, Varianten-ID],
  // Matrix als 0/1-Zeichenkette je Tür. Öffnet exakt denselben Plan im Rechner (Angebotsanfrage, Bestellung).
  function b64url(str) { return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function unb64url(code) {
    var b = code.replace(/-/g, '+').replace(/_/g, '/'); while (b.length % 4) b += '=';
    return decodeURIComponent(escape(atob(b)));
  }
  function planCode() {
    return b64url(JSON.stringify({
      v: 1, s: state.serie || '',
      d: state.doors.map(function (d) { var p = products[d.productIdx]; return [d.name || '', d.qty, p ? p.handle : '', d.variantId]; }),
      k: state.keys.map(function (k) { return [k.name || '', k.qty, k.variantId]; }),
      m: state.doors.map(function (d) { return state.keys.map(function (k) { return state.matrix[d.id + ':' + k.id] ? '1' : '0'; }).join(''); })
    }));
  }
  function planLink() {
    return window.location.origin + window.location.pathname + '#plan=' + planCode();
  }
  // Plan aus Link übernehmen. Rückgabe: Anzahl Hinweise (fehlende Produkte/Varianten) oder -1 bei ungültigem Code.
  function applyPlanCode(code) {
    var o;
    try { o = JSON.parse(unb64url(code)); } catch (e) { return -1; }
    if (!o || !o.d) return -1;
    var hinweise = 0, liste = serienListe();
    state = { doors: [], keys: [], matrix: {}, serie: (o.s && liste.indexOf(o.s) !== -1) ? o.s : (liste[0] || null) };
    syncKeyProduct();
    (o.d || []).forEach(function (x) {
      var idx = -1;
      for (var i = 0; i < products.length; i++) if (products[i].handle === x[2]) { idx = i; break; }
      if (idx === -1) { idx = defaultProductIdx(); hinweise++; }
      var vid = findVariant(products[idx] && products[idx].data, x[3]) ? x[3] : (hinweise++, defaultVariantId(idx));
      state.doors.push({ id: nextId('d'), name: x[0] || '', qty: Math.max(1, parseInt(x[1], 10) || 1), productIdx: idx, variantId: vid });
    });
    (o.k || []).forEach(function (x) {
      var vid = findVariant(keyProduct, x[2]) ? x[2] : (hinweise++, defaultKeyVariantId());
      state.keys.push({ id: nextId('k'), name: x[0] || '', qty: Math.max(1, parseInt(x[1], 10) || 1), variantId: vid });
    });
    state.doors.forEach(function (d, di) {
      var row = (o.m || [])[di] || '';
      state.keys.forEach(function (k, ki) { if (row.charAt(ki) === '1') state.matrix[d.id + ':' + k.id] = true; });
    });
    return hinweise;
  }

  /* ---------- Druckansicht / PDF ---------- */
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // inline=true: Dokument ersetzt die Seite (Link aus Warenkorb/Bestellbestätigung, #plan=…&druck=1), sonst Popup.
  function planDokumentHtml(inline, hinweise) {
    var t = totals();
    var h = [];
    h.push('<!doctype html><html lang="de"><head><meta charset="utf-8"><title>Schließplan ' + esc(new Date().toLocaleDateString('de-DE')) + '</title><style>',
      'body{font-family:Arial,Helvetica,sans-serif;font-size:11pt;color:#111;margin:18mm}',
      'h1{font-size:17pt;margin:0 0 2mm} h2{font-size:12.5pt;margin:7mm 0 2mm} .meta{color:#444;margin:0 0 4mm}',
      'table{border-collapse:collapse;width:100%} th,td{border:1px solid #999;padding:4px 6px;text-align:left;vertical-align:top}',
      'th{background:#eee} .mx td,.mx th{text-align:center} .mx td.l,.mx th.l{text-align:left} .x{font-weight:700}',
      '.sum td{border:none;padding:2px 6px} .sum td:last-child{text-align:right} .nw{white-space:nowrap} @page{size:A4;margin:12mm}',
      '@media print{body{margin:0}.noprint{display:none}}',
      '</style></head><body>');
    h.push('<p class="noprint"><button onclick="window.print()" style="font-size:12pt;padding:6px 14px;cursor:pointer">Drucken / als PDF speichern</button>' +
      (inline ? ' &nbsp; <a href="' + esc(planLink()) + '">Im Schließplanrechner öffnen</a> &nbsp; <a href="/">Zum Shop</a>' : '') + '</p>');
    if (hinweise > 0) h.push('<p class="noprint" style="color:#744210">Hinweis: ' + hinweise + ' Position(en) gibt es so nicht mehr im Shop – der Plan zeigt den heutigen Stand.</p>');
    h.push('<h1>Schließplan</h1><p class="meta">Kersten Sicherheitstechnik · ' + esc(state.serie || '') + ' · Stand ' + esc(new Date().toLocaleDateString('de-DE')) + '</p>');
    h.push('<h2>Schließmatrix</h2><table class="mx"><tr><th class="l">Zylinder / Tür</th>');
    state.keys.forEach(function (k, ki) { h.push('<th>S' + (ki + 1) + '<br><small>' + esc(k.name || 'Schlüssel') + ' (' + k.qty + '×)</small></th>'); });
    h.push('</tr>');
    state.doors.forEach(function (d, di) {
      h.push('<tr><td class="l"><b>Z' + (di + 1) + '</b> ' + esc(d.qty + '× ' + (d.name || 'Tür')) + '</td>');
      state.keys.forEach(function (k) { h.push('<td class="x">' + (state.matrix[d.id + ':' + k.id] ? 'X' : '') + '</td>'); });
      h.push('</tr>');
    });
    h.push('</table>');
    h.push('<h2>Zylinder</h2><table><tr><th>Pos.</th><th>Tür</th><th>Anzahl</th><th>Zylinder</th><th>Länge</th><th>Art.-Nr.</th><th>Einzelpreis</th></tr>');
    state.doors.forEach(function (d, di) {
      var p = products[d.productIdx], v = findVariant(p && p.data, d.variantId);
      h.push('<tr><td>Z' + (di + 1) + '</td><td>' + esc(d.name || 'Tür') + '</td><td>' + d.qty + '</td><td>' + esc(p ? p.label.replace(/\s*\(.*\)\s*$/, '') : '?') + '</td><td class="nw">' +
        esc(v ? variantLabel(p && p.data, v) : '—') + '</td><td class="nw">' + esc(v && v.sku ? v.sku : '') + '</td><td class="nw">' + (v ? money(v.price) : '—') + '</td></tr>');
    });
    h.push('</table><h2>Schlüssel</h2><table><tr><th>Pos.</th><th>Bezeichnung</th><th>Anzahl</th><th>davon inklusive</th><th>schließt</th></tr>');
    state.keys.forEach(function (k, ki) {
      var r = t.alloc.byId[k.id];
      h.push('<tr><td>S' + (ki + 1) + '</td><td>' + esc(k.name || 'Schlüssel') + '</td><td>' + k.qty + '</td><td>' + (r ? r.free : 0) + '</td><td>' + esc(doorsForKey(k).join(', ') || '—') + '</td></tr>');
    });
    h.push('</table><h2>Summe</h2><table class="sum">',
      '<tr><td>Zylinder (' + t.nDoors + ')</td><td>' + money(t.doors) + '</td></tr>',
      '<tr><td>Schlüssel (' + t.nKeys + ', davon ' + t.nFree + ' inklusive)</td><td>' + money(t.keys) + '</td></tr>',
      '<tr><td><b>Gesamt inkl. MwSt.</b></td><td><b>' + money(t.total) + '</b></td></tr></table>',
      '<p class="meta">Je Zylinder sind ' + KEYS_PER_CYL + ' Schlüssel inklusive. <a href="' + esc(planLink()) + '">Plan online öffnen</a></p></body></html>');
    return h.join('');
  }
  function printPlan() {
    var ort = (this && this.id === 'spr-success-print') ? 'nach_anfrage' : 'rechner';
    var html = planDokumentHtml(false, 0);
    var w = window.open('', '_blank');
    if (!w) { showMsg('err', 'Bitte Pop-ups für diese Seite erlauben, um den Schließplan zu drucken.'); return; }
    w.document.open(); w.document.write(html); w.document.close();
    var gp = gaBasis(); gp.ort = ort; track('rechner_drucken', gp);
    setTimeout(function () { try { w.focus(); w.print(); } catch (e) { /* Druckdialog optional */ } }, 300);
  }

  // Nach dem Absenden leitet Shopify auf diese Seite zurück (contact_posted=true bzw. Fehler):
  // Anfragebereich öffnen, Formular bei Erfolg ausblenden, Meldung ins Bild scrollen.
  function zeigeAnfrageErgebnis() {
    var ok = root.querySelector('#spr-offer-success'), err = root.querySelector('#spr-offer-errors');
    if (!ok && !err) return;
    var box = root.querySelector('#spr-offer');
    box.classList.add('spr-open');
    if (ok) box.classList.add('spr-offer-sent');
    var pb = root.querySelector('#spr-success-print');
    if (pb) pb.addEventListener('click', printPlan);
    var again = root.querySelector('#spr-offer-again');
    if (again) again.addEventListener('click', function () { box.classList.remove('spr-offer-sent'); ok.style.display = 'none'; });
    setTimeout(function () { (ok || err).scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
  }
  // Messung nach dem Absenden: „gesendet" nur, wenn diese Sitzung vorher wirklich abgeschickt hat
  // (Stand aus submitOffer) — ein Neuladen der Erfolgsseite zählt nicht doppelt. true = Ergebnisseite.
  function gaAnfrageErgebnis() {
    if (root.querySelector('#spr-offer-success')) {
      var snap = null, speicherOk = true;
      try { snap = sessionStorage.getItem(GA_ANFRAGE_KEY); sessionStorage.removeItem(GA_ANFRAGE_KEY); } catch (e) { speicherOk = false; }
      try { snap = snap ? JSON.parse(snap) : null; } catch (e) { snap = null; }
      if (snap || !speicherOk) track('rechner_anfrage_gesendet', gaMitWert(snap || gaBasis()));
      return true;
    }
    if (root.querySelector('#spr-offer-errors')) { track('rechner_anfrage_fehler', gaBasis()); return true; }
    return false;
  }

  /* ---------- Warenkorb ---------- */
  function showMsg(kind, text) {
    var m = root.querySelector('#spr-msg');
    m.className = 'spr-msg ' + (kind === 'err' ? 'spr-msg-err' : 'spr-msg-ok');
    m.textContent = text;
  }

  function addToCart() {
    var t = totals();
    if (t.incomplete || !state.doors.length) { showMsg('err', 'Bitte für jede Tür und jeden Schlüssel eine Variante wählen.'); return; }
    var btn = root.querySelector('#spr-add-to-cart');
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
    var items = [];
    state.doors.forEach(function (d, i) {
      items.push({
        id: d.variantId, quantity: d.qty,
        properties: {
          'Tür': d.name || ('Tür ' + (i + 1)),
          'Schließplan-Position': 'Z' + (i + 1),
          'Berechtigte Schlüssel': keysForDoor(d).join(', ') || '—',
          'Schlüssel inklusive': KEYS_PER_CYL + ' je Zylinder'
        }
      });
    });
    // Nur zusätzliche (berechnete) Schlüssel kommen als Position in den Warenkorb.
    // Inklusive Schlüssel stehen vollständig im Schließplan (Cart-Attribut) und im Positionstext.
    state.keys.forEach(function (k, i) {
      var r = t.alloc.byId[k.id];
      if (!r || r.paid <= 0) return;
      items.push({
        id: k.variantId, quantity: r.paid,
        properties: {
          'Schlüssel': k.name || ('Schlüssel ' + (i + 1)),
          'Schließplan-Position': 'S' + (i + 1),
          'Anzahl gesamt': String(k.qty),
          'davon inklusive': String(r.free),
          'Schließt Türen': doorsForKey(k).join(', ') || '—'
        }
      });
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('HTTP ' + r.status)); });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Schließplan zum Öffnen': planLink(), 'Schließplan': planText(), 'Schließplan-JSON': planJson() } })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart-Attribute konnten nicht gesetzt werden (HTTP ' + r.status + ')');
      // Messung: Übergabe an /cart (Section schliessplan-cart sendet rechner_warenkorb dort, sobald gtag da ist)
      try { sessionStorage.setItem('kst-spr-ga-warenkorb', JSON.stringify(gaParams(gaMitWert(gaBasis())))); } catch (e) { /* egal */ }
      window.location.href = '/cart';
    }).catch(function (e) {
      showMsg('err', 'Fehler beim Hinzufügen: ' + e.message);
      btn.disabled = false; btn.textContent = 'In den Warenkorb';
    });
  }

  /* ---------- Angebotsanfrage (Shopify /contact-Form) ---------- */
  function submitOffer() {
    // Echter Form-POST an /contact: falls der Shop Captcha verlangt,
    // zeigt Shopify die Challenge-Seite — deshalb kein fetch().
    var f = root.querySelector('#spr-offer-form');
    f.querySelector('[name="contact[Schließplan]"]').value = planText();
    var sb = f.querySelector('#spr-offer-submit');
    if (sb) { sb.disabled = true; sb.textContent = 'Wird gesendet …'; }   // Doppelklick verhindern
    var lf = f.querySelector('[name="contact[Schließplan zum Öffnen]"]');
    if (lf) lf.value = planLink();
    // Messung: „gesendet" erst auf der Erfolgsseite (contact_posted) mit diesem Stand (der POST verlässt die Seite).
    try { sessionStorage.setItem(GA_ANFRAGE_KEY, JSON.stringify(gaBasis())); } catch (e) { /* egal */ }
  }


  /* ---------- Plan sichern / teilen (29.10.2026) ---------- */
  // Ein Panel (#spr-share-panel, in der Zusammenfassung), zwei Öffner (Toolbar + Button bei den Aktionen).
  // Zweck: Handy-Nutzer nehmen den Plan per Link mit an den PC, Hausverwaltung/Eigentümer bekommen denselben Plan.
  function sharePanel() { return root.querySelector('#spr-share-panel'); }
  function shareStatus(txt, fehler) {
    var st = root.querySelector('#spr-share-status'); if (!st) return;
    st.textContent = txt || ''; st.className = 'spr-share-status' + (fehler ? ' spr-share-status-err' : '');
  }
  function shareMailHref(link) {
    var betreff = 'Mein Schließplan – Kersten Sicherheitstechnik';
    var text = 'Mein Schließplan bei Kersten Sicherheitstechnik:\n\n' + link + '\n\nLink öffnen, um den Plan weiterzubearbeiten, anzufragen oder zu bestellen.';
    return 'mailto:?subject=' + encodeURIComponent(betreff) + '&body=' + encodeURIComponent(text);
  }
  function shareRefresh() {
    var pan = sharePanel(); if (!pan) return null;
    var link = planLink();
    var inp = pan.querySelector('#spr-share-link'); if (inp) inp.value = link;
    var ml = pan.querySelector('#spr-share-mail'); if (ml) ml.setAttribute('href', shareMailHref(link));
    var nat = pan.querySelector('#spr-share-native');
    if (nat) nat.hidden = !(navigator.share && typeof navigator.share === 'function');
    return link;
  }
  function shareOpen(ort) {
    var pan = sharePanel(); if (!pan) return;
    if (!state.doors.length) { shareStatus('Legen Sie zuerst mindestens eine Tür an.', true); }
    else shareStatus('');
    shareRefresh();
    pan.hidden = false;
    try { pan.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* egal */ }
    var p = gaBasis(); p.ort = ort || 'toolbar'; track('rechner_plan_sichern_geoeffnet', p);
  }
  function shareTrack(methode) { var p = gaBasis(); p.methode = methode; track('rechner_plan_gesichert', p); }
  function shareCopy() {
    var link = shareRefresh(); if (!link) return;
    var inp = root.querySelector('#spr-share-link');
    function fertig() { shareStatus('Link kopiert. Am PC einfügen oder weiterleiten – der Plan ist komplett im Link enthalten.'); shareTrack('kopiert'); }
    function fallback() {
      try { inp.focus(); inp.select(); inp.setSelectionRange(0, link.length); var okc = document.execCommand && document.execCommand('copy'); if (okc) return fertig(); } catch (e) { /* weiter */ }
      shareStatus('Kopieren nicht möglich – bitte den Link im Feld markieren und kopieren.', true);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(fertig, fallback); else fallback();
  }
  function shareNative() {
    var link = shareRefresh(); if (!link || !navigator.share) return;
    navigator.share({ title: 'Mein Schließplan – Kersten Sicherheitstechnik', text: 'Mein Schließplan bei Kersten Sicherheitstechnik', url: link })
      .then(function () { shareStatus('Plan geteilt.'); shareTrack('geteilt'); }, function () { /* abgebrochen */ });
  }
  function offerOpen(quelle) {
    var off = root.querySelector('#spr-offer'); if (!off) return;
    if (!off.classList.contains('spr-open')) root.querySelector('#spr-offer-toggle').click();
    try { off.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { /* egal */ }
    if (quelle) { var p = gaBasis(); p.quelle = quelle; track('rechner_anfrage_aus_plan_sichern', p); }
  }
  // Direktanfrage-Box oben („Schließplan schon vorhanden?"): Klicks auf Mail/Telefon messen
  function direktTracking() {
    document.querySelectorAll('[data-spr-direkt]').forEach(function (a) {
      a.addEventListener('click', function () { var p = gaBasis(); p.kanal = a.getAttribute('data-spr-direkt'); track('rechner_direktanfrage', p); });
    });
  }

  /* ---------- Init ---------- */
  // Produktdaten laden; bei Drosselung (429) oder Serverfehler bis zu 4 Wiederholungen mit wachsender Wartezeit.
  function loadProduct(handle, versuch) {
    versuch = versuch || 0;
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if ((r.status === 429 || r.status >= 500) && versuch < 4) {
          return new Promise(function (res) { setTimeout(res, 700 * Math.pow(2, versuch) + Math.random() * 300); })
            .then(function () { return loadProduct(handle, versuch + 1); });
        }
        if (!r.ok) throw new Error(handle + ': HTTP ' + r.status);
        return r.json();
      });
  }

  var handles = CFG.products || [];
  var keyDefs = (CFG.keyProducts || []).filter(function (k) { return k && k.handle; });
  var extra = keyDefs.map(function (k) { return k.handle; });
  if (CFG.keyProduct) extra.push(CFG.keyProduct);
  var alleHandles = handles.map(function (p) { return p.handle; }).concat(extra);
  Promise.all(alleHandles.map(function (h, i) {
    return new Promise(function (res) { setTimeout(res, i * 120); }).then(function () { return loadProduct(h); });
  })).then(function (results) {
    products = handles.map(function (p, i) { return { handle: p.handle, label: p.label || results[i].title, serie: p.serie || '', data: results[i] }; });
    keyDefs.forEach(function (k, i) { keyProductsBySerie[k.serie || ''] = results[handles.length + i]; });
    if (CFG.keyProduct) keyProductDefault = results[results.length - 1];
    root.querySelector('#spr-loading').style.display = 'none';
    root.querySelector('#spr-main').style.display = 'block';
    var restored = restore();
    var linkPlan = /[#&]plan=([A-Za-z0-9_-]+)/.exec(window.location.hash || '');
    var liste = serienListe();
    // Gespeicherte Serie nur übernehmen, wenn es sie noch gibt.
    if (!state.serie || liste.indexOf(state.serie) === -1) state.serie = liste.length ? liste[0] : null;
    syncKeyProduct();
    renderSerien();
    var gaStart = linkPlan ? 'plan_link' : (restored ? 'gespeicherter_plan' : 'startvorlage');
    if (linkPlan) {
      var hw = applyPlanCode(linkPlan[1]);
      if (hw === -1) gaStart = 'plan_link_ungueltig';
      var ban = document.createElement('p');
      ban.className = 'spr-plan-banner' + (hw ? ' spr-plan-banner-warn' : '');
      ban.textContent = hw === -1 ? 'Der Schließplan-Link ist ungültig oder unvollständig.'
        : 'Schließplan aus Link geladen.' + (hw ? ' Hinweis: ' + hw + ' Position(en) gibt es so nicht mehr, bitte prüfen.' : '');
      var mainEl = root.querySelector('#spr-main'); mainEl.insertBefore(ban, mainEl.firstChild);
      if (hw !== -1 && /[#&]druck=1/.test(window.location.hash || '')) {
        // Dokumentansicht: Seite durch das Schließplan-Dokument ersetzen (aus Warenkorb / Bestellbestätigung)
        var doc = planDokumentHtml(true, hw);
        var gd = gaBasis(); gd.start = 'plan_dokument'; track('rechner_geoeffnet', gd);
        document.open(); document.write(doc); document.close();
        return;
      }
      if (hw !== -1) { renderSerien(); save(); } else if (!restored) applyTemplate('efh');
    } else if (!restored) applyTemplate('efh');
    render();
    zeigeAnfrageErgebnis();
    // Messung: Rückkehr nach dem Absenden (Erfolg/Fehler) ist kein neues „Öffnen"
    if (!gaAnfrageErgebnis()) { var go = gaBasis(); go.start = gaStart; track('rechner_geoeffnet', go); }
  }).catch(function (e) {
    root.querySelector('#spr-loading').textContent = 'Produktdaten konnten nicht geladen werden: ' + e.message;
  });

  // Toolbar + Buttons
  root.querySelectorAll('[data-spr-template]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.doors.length && !window.confirm('Aktuelle Konfiguration verwerfen und Vorlage laden?')) return;
      applyTemplate(b.getAttribute('data-spr-template'));
      track('rechner_vorlage_gewaehlt', gaBasis());
    });
  });
  root.querySelector('#spr-clear').addEventListener('click', clearConfig);
  var pb = root.querySelector('#spr-print');
  if (pb) pb.addEventListener('click', printPlan);
  root.querySelector('#spr-add-to-cart').addEventListener('click', addToCart);
  [['#spr-share', 'toolbar'], ['#spr-share-2', 'aktionen']].forEach(function (x) {
    var b = root.querySelector(x[0]); if (b) b.addEventListener('click', function () { shareOpen(x[1]); });
  });
  var sc = root.querySelector('#spr-share-copy'); if (sc) sc.addEventListener('click', shareCopy);
  var sm = root.querySelector('#spr-share-mail'); if (sm) sm.addEventListener('click', function () { shareRefresh(); shareTrack('mail'); });
  var sn = root.querySelector('#spr-share-native'); if (sn) sn.addEventListener('click', shareNative);
  var so = root.querySelector('#spr-share-offer'); if (so) so.addEventListener('click', function () { offerOpen('plan_sichern'); });
  var sx = root.querySelector('#spr-share-close'); if (sx) sx.addEventListener('click', function () { var pan = sharePanel(); if (pan) pan.hidden = true; });
  direktTracking();
  var gaFormularGemeldet = false;
  root.querySelector('#spr-offer-toggle').addEventListener('click', function () {
    root.querySelector('#spr-offer').classList.toggle('spr-open');
    if (!gaFormularGemeldet && root.querySelector('#spr-offer').classList.contains('spr-open')) {
      gaFormularGemeldet = true; track('rechner_anfrage_formular_geoeffnet', gaBasis());
    }
  });
  root.querySelector('#spr-offer-form').addEventListener('submit', submitOffer);
  // Zurück-Navigation (bfcache): gesperrten Sendeknopf wieder freigeben
  window.addEventListener('pageshow', function () {
    var sb = root.querySelector('#spr-offer-submit');
    if (sb && sb.disabled) { sb.disabled = false; sb.textContent = 'Anfrage senden'; }
  });
})();
